import { Project } from 'mdello-client-ts/dist/src/interfaces/common/project.interface';
import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { fetchContentsData } from 'src/services/napi/Contents/fetchContentsData';
import { FetchContentsResponseData } from 'src/services/napi/Contents/fetchContentsData/interfaces/fetchContentsResponseData.interface';

const fetchContents = async (params: {
  customTypeId?: string;
  isHighlighted?: string;
  orderBy?: string;
  orderDirection?: string;
  page?: string;
  pageSize?: string;
  searchItem?: string;
}): Promise<FetchContentsResponseData | undefined> => {
  const {
    orderBy,
    orderDirection,
    page,
    pageSize,
    customTypeId,
    searchItem,
    isHighlighted
  } = params;
  const currentProject: Project | undefined = getDataFromLocalStorage(
    LocalStorageKey.CURRENT_PROJECT
  );
  if (!currentProject) return;

  const data = await fetchContentsData({
    customTypeId: !customTypeId || customTypeId === 'All' ? '' : customTypeId,
    isHighlighted: isHighlighted || '0',
    orderBy: orderBy || 'created',
    orderDirection: orderDirection || '-1',
    page: page || '1',
    pageSize: pageSize || '10',
    projectId: currentProject._id,
    searchItem: searchItem || ''
  });
  return data;
};

export const useGetContentsQuery = (params: {
  customTypeId?: string;
  isHighlighted?: string;
  orderBy?: string;
  orderDirection?: string;
  page?: string;
  pageSize?: string;
  searchItem?: string;
}) => {
  const { notify } = useNotification();
  const {
    orderBy,
    orderDirection,
    page,
    pageSize,
    customTypeId,
    searchItem,
    isHighlighted
  } = params;

  return useQuery(
    [
      QueryKey.CONTENT_REVIEWS,
      page,
      pageSize,
      orderBy,
      orderDirection,
      customTypeId,
      searchItem,
      isHighlighted
    ],
    () =>
      fetchContents({
        customTypeId,
        isHighlighted,
        orderBy,
        orderDirection,
        page,
        pageSize,
        searchItem
      }),
    {
      keepPreviousData: true,
      onError: () => {
        notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      }
    }
  );
};
